import { Outlet } from 'react-router';
import { Toaster } from 'sonner';

export default function HomeLayout() {
  return (
    <div className="min-h-screen text-foreground">
      <Outlet />
      <Toaster theme="system" position="bottom-right" />
    </div>
  );
}
